import {
  BranchYearDTO,
  IBranchDTO,
  IBranchYearDTO,
  IPaginationDTO,
  ITeamDTO,
  IUserDTO,
  IYearDTO,
} from '@/dtos';
import { get, generatePagination, post, remove } from '@/services/apiWrapper';

export const getBranchesAPI = async (
  pagination: IPaginationDTO,
): Promise<{ data: IBranchDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const branches = await get<{ data: IBranchDTO[]; count: number }>(
    `/admin/branches${pageOptions}`,
  );
  return branches;
};
export const getBranchesForYearAdminAPI = async (
  yearId: string,
  pagination: IPaginationDTO,
): Promise<{ data: IBranchDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const branches = await get<{ data: IBranchDTO[]; count: number }>(
    `/admin/branches/year/${yearId}${pageOptions}`,
  );
  return branches;
};

export const createBranchAPI = async (body: IBranchDTO): Promise<IBranchDTO> => {
  const branch = await post<IBranchDTO>(`/admin/branches/createBranch`, body);
  return branch;
};

export const getBranchByIdAPI = async (branchId: string): Promise<IBranchDTO> => {
  const branch = await get<IBranchDTO>(`/admin/branches/${branchId}`);
  return branch;
};

export const saveBranchApi = async (branch: IBranchDTO): Promise<IBranchDTO> => {
  const ret = await post<IBranchDTO>(`/admin/branches/${branch.id}/save`, branch);
  return ret;
};

/********* Branch Admins **********/

export const getBranchAdminsAPI = async (
  branchId: string,
  pagination: IPaginationDTO,
): Promise<{ data: IUserDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const branchAdmins = await get<{ data: IUserDTO[]; count: number }>(
    `/admin/branches/${branchId}/admins${pageOptions}`,
  );
  return branchAdmins;
};

export const getPossibleBranchAdminsAPI = async (
  branchId: string,
  pagination: IPaginationDTO,
): Promise<{ data: IUserDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const branchAdmins = await get<{ data: IUserDTO[]; count: number }>(
    `/admin/branches/${branchId}/possibleadmins${pageOptions}`,
  );
  return branchAdmins;
};

export const addAdminsToBranchAPI = async (branchId: string, data: string[]): Promise<boolean> => {
  const admins = await post<boolean>(`/admin/branches/${branchId}/admins`, { ids: data });
  return admins;
};
export const removeAdminFromBranchAPI = async (
  branchId: string,
  userId: string,
): Promise<boolean> => {
  const admins = await remove<boolean>(`/admin/branches/${branchId}/admins/${userId}`);
  return admins;
};

/********* Branch Years **********/

export const getBranchYearsAPI = async (
  branchId: string,
  pagination: IPaginationDTO,
): Promise<{ data: IBranchYearDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const branchAdmins = await get<{ data: IBranchYearDTO[]; count: number }>(
    `/admin/branches/${branchId}/years${pageOptions}`,
  );
  return branchAdmins;
};

export const getPossibleBranchYearsAPI = async (
  branchId: string,
  pagination: IPaginationDTO,
): Promise<{ data: IYearDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const branchAdmins = await get<{ data: IYearDTO[]; count: number }>(
    `/admin/branches/${branchId}/possibleyears${pageOptions}`,
  );
  return branchAdmins;
};

export const addBranchToYearAPI = async (branchId: string, data: string[]): Promise<boolean> => {
  const admins = await post<boolean>(`/admin/branches/${branchId}/years`, { ids: data });
  return admins;
};
export const removeBranchFromYearAPI = async (
  branchId: string,
  yearId: string,
): Promise<boolean> => {
  const admins = await remove<boolean>(`/admin/branches/${branchId}/years/${yearId}`);
  return admins;
};

export const getBranchYearAPI = async (
  branchId: string,
  yearId: string,
): Promise<BranchYearDTO> => {
  const branchYears = await get<BranchYearDTO>(`/admin/branches/${branchId}/years/${yearId}`);
  return branchYears;
};

export const updateBranchYearAPI = async (branchYear: IBranchYearDTO): Promise<BranchYearDTO> => {
  const obj = await post<BranchYearDTO>(
    `/admin/branches/${branchYear.branch?.id}/years/${branchYear.year?.id}`,
    branchYear,
  );
  return obj;
};

export const getTeamsForBranchYearAPI = async (
  branchId: string,
  yearId: string,
  pagination: IPaginationDTO,
): Promise<{ data: ITeamDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const branchYears = await get<{ data: ITeamDTO[]; count: number }>(
    `/admin/branches/${branchId}/years/${yearId}/teams${pageOptions}`,
  );
  return branchYears;
};
